import React from 'react';
import PropTypes from 'prop-types';
import { Link, ShareEmailIcon } from '@paypalcorp/pp-react';
import { grey600 } from '@paypalcorp/pp-react-colors';
function SocialShareEmail({
  url,
  handleAnalytics,
  linkTitle,
  color = grey600,
}) {
  return (
    <Link
      href={url}
      onClick={() => handleAnalytics('email-share')}
      style={{ color }}
      title={linkTitle}
      data-testid="social-share-email"
    >
      <ShareEmailIcon size="lg" />
    </Link>
  );
}

SocialShareEmail.propTypes = {
  url: PropTypes.string,
  handleAnalytics: PropTypes.func,
  linkTitle: PropTypes.string,
  color: PropTypes.string,
};

export default SocialShareEmail;
